import { Box, IconButton, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';

import { ReactComponent as BackIcon } from '../../../../assets/icons/back.svg';
import { ReactComponent as CloseIcon } from '../../../../assets/icons/close.svg';
import { ReactComponent as OpenInNewIcon } from '../../../../assets/icons/open-new.svg';
import { modalColors } from '../DiscussionsModal/styled';

interface ConversationHeaderProps {
    title: string;
    subtitle?: string | null;
    onClose?: () => void;
    showCloseButton?: boolean;
    showBackButton?: boolean;
    navigateTo?: string | null;
}

export default function ConversationHeader({
    title,
    subtitle = null,
    onClose,
    showCloseButton = true,
    showBackButton = false,
    navigateTo = null
}: ConversationHeaderProps): JSX.Element {
    const history = useHistory();

    const handleNavigateTo = () => {
        if (navigateTo) {
            history.push(navigateTo);
        }
    };

    const headerStyles = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid #404040',
        paddingTop: '16px',
        paddingBottom: '16px',
        paddingLeft: '16px',
        paddingRight: '16px'
    };

    const titleTextStyles = {
        fontWeight: 600,
        marginBottom: '4px'
    };

    const subtitleBoxStyles = {
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    };

    const subtitleTextStyles = {
        color: modalColors.white30,
        fontSize: '14px'
    };

    const closeButtonStyles = {
        color: '#888'
    };

    const backButtonStyles = {
        color: '#888'
    };

    return (
        <Box sx={headerStyles}>
            <Box>
                <Typography variant="h6" sx={titleTextStyles}>
                    {title}
                </Typography>
                {subtitle && (
                    <Box sx={subtitleBoxStyles}>
                        <Typography variant="caption" sx={subtitleTextStyles}>
                            {subtitle || 'Conversation'}
                        </Typography>
                        {navigateTo && (
                            <IconButton
                                onClick={handleNavigateTo}
                                size="small"
                                sx={{
                                    padding: '2px',
                                    color: modalColors.white30
                                }}
                            >
                                <OpenInNewIcon />
                            </IconButton>
                        )}
                    </Box>
                )}
            </Box>
            {(showCloseButton || showBackButton) && onClose && (
                <IconButton
                    onClick={onClose}
                    sx={showBackButton ? backButtonStyles : closeButtonStyles}
                >
                    {showBackButton ? <BackIcon /> : <CloseIcon />}
                </IconButton>
            )}
        </Box>
    );
}
